import CNotify from './CNotify.svelte';
import { BROWSER } from 'esm-env';
if (BROWSER) {
    if (!document.querySelector('.notifications-holder')) {
        const defaultContainer = document.createElement('div');
        defaultContainer.classList.add('notifications-holder');
        document.body.append(defaultContainer);
    }
}
const DEFAULT_TIMEOUT = 4000;
function send({ title, text, html, timeout = DEFAULT_TIMEOUT, type, target = '.notifications-holder' }) {
    const container = document.querySelector(target);
    if (!container)
        throw 'Missing target element for Display notifications';
    const props = {
        title,
        text,
        html
    };
    const noty = new CNotify({
        target: container,
        props: {
            ...props,
            type,
            visible: true
        },
        intro: true
    });
    let timer;
    if (timeout) {
        timer = setTimeout(() => {
            noty.close();
        }, timeout);
    }
    noty.$on('close', () => {
        noty.$destroy();
        if (timer) {
            clearTimeout(timer);
        }
    });
    window.dispatchEvent(new CustomEvent(`notifier-${type}`, { detail: props }));
}
function error(opt) {
    send({ ...parseOpts(opt), type: 'error' });
}
function info(opt) {
    send({ ...parseOpts(opt), type: 'brand' });
}
function success(opt) {
    send({ ...parseOpts(opt), type: 'success' });
}
function parseOpts(opt) {
    if (typeof opt === 'string') {
        return {
            title: opt
        };
    }
    return opt;
}
function onSend(type, callback, opts) {
    const trigger = (e) => {
        callback(e.detail);
    };
    //@ts-ignore
    window.addEventListener(`notifier-${type}`, trigger, opts);
    return () => {
        //@ts-ignore
        window.removeEventListener(`notifier-${type}`, trigger, opts);
    };
}
export const CNotifier = {
    error,
    info,
    success,
    on: onSend
};
